// extracted by mini-css-extract-plugin
module.exports = {"KnowiDashboard":"KnowiDashboard_KnowiDashboard__2TB6e","progressContainer":"KnowiDashboard_progressContainer__3bNmv","progress":"KnowiDashboard_progress__2sLsa"};